import React from "react";
import Button from "components/Elements/Button/Button";
import config from "../../../../../../config";
import Image from "components/Elements/Image/Image";
import { AdsData } from "./UploadCompleteBody";

interface AdvertiseSectionI {
  adsData: AdsData | null;
  loading: boolean;
}

const AdvertiseSection = ({ adsData, loading }: AdvertiseSectionI) => {
  const handleAdvertiseButtonClick = () => {
    if (adsData?.NotificationLinkUrl) {
      const fullUrl = `${config!.baseurl}${adsData.NotificationLinkUrl}`;
      window.open(fullUrl, "_blank", "noopener,noreferrer");
    }
  };

  const parseTitle = (title: string) => {
    if (!title) return { mainText: "", link: null };

    const linkMatch = title.match(/<a[^>]*href="([^"]+)"[^>]*>([^<]+)<\/a>/);

    if (linkMatch) {
      const [fullMatch, href, linkText] = linkMatch;
      const mainText = title.replace(fullMatch, "").trim();

      const fullHref = href.startsWith("http")
        ? href
        : `${config!.baseurl}${href}`;

      return {
        mainText,
        link: {
          href: fullHref,
          text: linkText,
        },
      };
    }

    return {
      mainText: title,
      link: null,
    };
  };

  const parsedTitle = parseTitle(
    adsData?.NotificationTitle ? adsData?.NotificationTitle : ""
  );

  if (loading || !adsData) {
    return (
      <div className="advertise-section loading-wrap">
        {/* <Image
          name="preloader"
          ext="gif"
          alt="loading"
          style={{ width: "40px" }}
        /> */}
      </div>
    );
  }

  return (
    <div className="advertise-section">
      <div className="advertise-content">
        <h3>
          {parsedTitle.mainText}
          {parsedTitle.link && (
            <>
              {" "}
              <a
                href={parsedTitle.link.href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(parsedTitle.link!.href, "_blank");
                }}
              >
                {parsedTitle.link.text}
              </a>
            </>
          )}
        </h3>
        <p>{adsData.NotificationText}</p>
        <Button
          className="advertise-button"
          onClick={handleAdvertiseButtonClick}
        >
          {adsData.ButtonText}
        </Button>
      </div>
      <div className="advertise-image">
        <img
          src={
            window.innerWidth > 769
              ? adsData.NotificationImage
              : adsData.NotificationMobileImage
          }
          alt=""
        />
      </div>
    </div>
  );
};

export default AdvertiseSection;
